import React,{useState,useEffect} from 'react'
import { useAuthContext } from '../../context/Auth/Create'
import { graphData } from '../../sdk'
import { Loader } from '../Default'
import { AgeViseArea } from './AgeViseArea'
import { AgreeGateArea } from './AgreeGateArea'
import { GenderViseArea } from './GenderViseArea'
export const Combined=()=> {
    const [state,setState]=useState({loader:true,floorViseData:{},genderViseData:{},ageViseData:{}});
    const userAuth=useAuthContext();
    const apiData=async()=>{
        try{
        let result=await new graphData().viseData();
         setState((pre)=>{
            return {...pre,...result,loader:false}
         })
        }catch(e){
            console.log(e)
        alert("error occur")
        }

    }
    
    useEffect(()=>{
       apiData();
    },[])
   
  if(!state.loader){
    return (
        <>
        {/* <AgreeGateArea data={state.floorViseData}/> */}
        {userAuth.user.permissions.includes("AgeGender") &&  <>
        <GenderViseArea data={state.genderViseData}/>
        <AgeViseArea data={state.ageViseData}/>
        </> }
      
        </>
      )
  }
  else{
    return (<>
    <Loader/>
    </>)
  }
}
